import "../index";

import { getAuth, signInWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";

const auth = getAuth();
const db = getFirestore();
var alertInfo = document.querySelector("#alert");
var alertResetInfo = document.querySelector("#reset-alert");
var loginButton = document.querySelector("#login-button");

document.querySelector("#form-signin").addEventListener("submit", (e) => {
    e.preventDefault();

    alertInfo.innerHTML = "";
    loginButton.innerHTML = `<div class="spinner-border text-light spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>`
    loginButton.disabled = true;

    var email = document.getElementById("inputEmail").value.trim();
    var password = document.getElementById("inputPassword").value;

    signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            const judge = userCredential.user;

            // Check if judge had verified the email
            dataCheck(judge.uid).then((isJudge) => {
                if (isJudge) {
                    if (judge.emailVerified) {
                        window.location.href = "/judge/dashboard.html";
                    } else {
                        var actionCodeSettings = {
                            url: 'https://vhackusm.com/judge/dashboard.html'
                        };

                        sendEmailVerification(auth.currentUser, actionCodeSettings)
                            .then(() => {
                                alertInfo.innerHTML = `<div class="alert alert-success" role="alert">Please check your email for verification!</div>`;
                                resetSpinner();
                            })
                            .catch((error) => {
                                switch (error.code) {
                                    case "auth/too-many-requests":
                                        setAlert("Too many requests! Please try again later.");
                                        break;
                                    default:
                                        setAlert(`${error.message} (Please contact judge@vhackusm.com)`);
                                        break;
                                }
                            });
                        resetSpinner();
                    }
                } else {
                    setAlert(`You're not authorized to use this portal.`);
                }
            }).catch((error) => {
                if (error.code == "permission-denied") setAlert(`You're not authorized to use this portal.`);
                else setAlert(`${error.message} (Please contact judge@vhackusm.com)`);
            })
        })
        .catch((error) => {
            const errorCode = error.code;

            switch (errorCode) {
                case "auth/invalid-email":
                    setAlert("Invalid email!");
                    break;
                case "auth/user-disabled":
                    setAlert("User disabled!");
                    break;
                case "auth/user-not-found":
                case "auth/wrong-password":
                    setAlert("Wrong email or password!");
                    break;
                case "auth/too-many-requests":
                    setAlert("Your account is temporarily disabled due to multiple failed sign in attempts. Please try again later.");
                    break;
                default:
                    setAlert(`${error.message} (Please contact judge@vhackusm.com)`);
                    break;
            }
            resetSpinner();
        });
});

document.querySelector("#reset-button").addEventListener("click", (e) => {
    e.preventDefault();
    const button = document.querySelector("#reset-button");
    button.innerHTML = `<div class="spinner-border text-light spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>`;
    button.disabled = true;
    
    var email = document.querySelector("#inputEmailReset");

    sendPasswordResetEmail(auth, email.value)
        .then(() => {
            button.innerHTML = `Reset password`;
            button.disabled = false;
            setAlertReset();
        })
        .catch((error) => {
            button.innerHTML = `Reset password`;
            button.disabled = false;
            setAlertReset();
        });
}, false);

function resetSpinner() {
    loginButton.disabled = false;
    loginButton.innerHTML = "Sign in";
}

async function dataCheck(uid) {
    const docRef = doc(db, "judges", uid);
    const docSnap = await getDoc(docRef);
    return docSnap.exists();
}

function setAlert(msg) {
    alertInfo.innerHTML = `<div class="alert alert-warning" role="alert">${msg}</div>`;
    resetSpinner();
}

function setAlertReset() {
    alertResetInfo.innerHTML = `<div class="alert alert-primary" role="alert">A reset password email is sent your way if the account exists.</div>`;
}

